// 视频页
import * as React from 'react'

import get from 'lodash/get'
import fetch from 'isomorphic-unfetch'
import { withRouter, SingletonRouter } from 'next/router'

import getUrl from 'lib/url'
import Head from 'Components/head'
import {
  DEFAULT_VIDEO_KEYWORDS,
  DEFAULT_VIDEO_DESCRIPTION,
} from 'Constants/index'

import RecommandVideos from './recommand-video'
import PopularColumns, { IPopularColumn } from './popular-columns'
import Banner, { IBanner } from './banner'
import { IAdData } from '../ad/interface'

interface IVideoProps {
  popularColumns: IPopularColumn[]
  banner: IBanner[]
  router: SingletonRouter
}

function Video(props: IVideoProps) {
  const [bannerAd, setBannerAd] = React.useState<IAdData[]>([])
  React.useEffect(() => {
    fetch(getUrl('/motor/ad/m/pc/video/common'), {
      credentials: 'include',
    })
      .then(res => res.json())
      .then(res => {
        setBannerAd(res.data.pc_video_rolls)
      })
  }, [])
  const { popularColumns, banner } = props
  return (
    <section>
      <Head
        title="汽车视频 - 新车试驾 - 新车评测 - 懂车帝"
        keywords={DEFAULT_VIDEO_KEYWORDS}
        description={DEFAULT_VIDEO_DESCRIPTION}
      />
      {banner.length > 0 ? (
        <Banner banner={banner} bannerAd={bannerAd} />
      ) : null}
      <PopularColumns columns={popularColumns} />
      <RecommandVideos />
      <style jsx>
        {`
          section {
            width: 1190px;
            margin: 24px auto 0 auto;
          }
        `}
      </style>
    </section>
  )
}

Video.getInitialProps = async () => {
  const [banner, columns] = await Promise.all([
    fetch(
      getUrl('/motor/card/common_cate_head/v1/?category=pc_tt_car_channel')
    ).then(res => res.json()),
    fetch(
      getUrl('/motor/pleasure/collection/general-index?latest=1')
    ).then(res => res.json()),
  ])

  let popularColumns = []
  if (columns && columns.data) {
    popularColumns = columns.data.slice(0, 4)
  }
  return {
    popularColumns,
    banner: get(banner, 'data.list[0].info.series_banner_items', []),
  }
}
export default withRouter<IVideoProps>(Video)
